// Slices last part of current route for use in back button etc.
export default {
  created() {
    this.sliceLastPartRoute()
  },
  watch: {
    $route() {
      this.sliceLastPartRoute()
    }
  },
  methods: {
    sliceLastPartRoute() {
      const path = this.$route.path

      // Remove trailing slash
      const pathChars = path.split('')
      const trailingSlashMaybe = pathChars.pop()

      const pathWithoutTrailingSlash = trailingSlashMaybe === '/' ? pathChars.splice(-1, 1).join() : path

      // Back as in one dir up
      const lastPath = pathWithoutTrailingSlash.lastIndexOf('/')
      const target = pathWithoutTrailingSlash.substr(0, lastPath) || 'welcome'

      this.back = target
    }
  }
}
